import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  getInternalErrorDetails,
  useShowInternalErrorDetails,
} from "shared/utils/ErrorUtils";

export interface InternalErrorDetailsProps {
  error: unknown;
}

export const InternalErrorDetails: React.FC<InternalErrorDetailsProps> = ({
  error,
}) => {
  const showInternalErrorDetails = useShowInternalErrorDetails();
  const { t } = useTranslation(["common"]);
  const details = getInternalErrorDetails(error);
  if (!showInternalErrorDetails || !details) {
    return null;
  }
  return (
    <Box
      borderWidth="1px"
      padding="8px"
      borderRadius="6px"
      borderColor="purple.200"
      bg="purple.25"
      color="purple.900"
      textAlign="left"
    >
      <Text textStyle="overline" color="purple.500" cursor="pointer">
        {t("common:internalErrorDetails")}
      </Text>
      <Text fontFamily="mono" whiteSpace="pre-wrap" textStyle="small">
        {details}
      </Text>
    </Box>
  );
};
